<template>
  <v-dialog max-width="500px" persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title class="headline">{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="cancel()">close</v-icon>
      </v-toolbar>

      <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field v-model="selected_item.store_service_name_th" label="Store Service Name TH"></v-text-field>
          <v-text-field v-model="selected_item.store_service_name_en" label="Store Service Name EN"></v-text-field>
          <v-text-field v-model="selected_item.store_service_name_cn" label="Store Service Name CN"></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="cancel()">Cancel</v-btn>
        <v-btn color="green" :disabled="isEditStoreList" flat @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["dialog", "editedIndex", "selected_item"],
  data() {
    return {
      valid: true
    };
  },
  computed: {
    ...mapGetters(["isEditStoreList"]),
    formTitle() {
      return this.editedIndex === -1
        ? "New store service"
        : "Edit store service";
    }
  },
  methods: {
    async save() {
      let sendData = {
        store_service_name_th: this.selected_item.store_service_name_th,
        store_service_name_en: this.selected_item.store_service_name_en,
        store_service_name_cn: this.selected_item.store_service_name_cn
      };
      if (this.editedIndex == -1) {
        this.$store.dispatch("fetchStoreBack/addService", sendData);
        this.$emit("save");
      } else {
        this.$emit("setDialog");
        let check_success = await this.$store.dispatch(
          "fetchStoreBack/editService",
          this.selected_item
        );
        if (check_success == false) {
          this.$emit("cancel");
        } else {
          this.$emit("save");
        }
      }
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>



